'use client';
import { selectExtraStateItems } from '@/lib/redux/app.selectors';
import { setExtraStateItems } from '@/lib/redux/app.slice';
import { useAppDispatch } from '@/lib/redux/store';
import { Editor } from '@tiptap/react';
import classNames from 'classnames';
import EmojiPicker, { Theme } from 'emoji-picker-react';
import { useSelector } from 'react-redux';
import useTextEditor from './hooks/useTextEditor';
import { TemplateAttribute } from './types';

interface FloatingEmojiDropdownProps {
  className?: string;
  onSelect?: (attribute: TemplateAttribute) => void;
  editor: Editor | null;
  isOpen?: boolean;
}

const FloatingEmojiDropdown = ({
  className,
  editor,
  isOpen,
}: FloatingEmojiDropdownProps) => {
  const dispatch = useAppDispatch();
  const extraItems = useSelector(selectExtraStateItems);
  const { skinTone } = extraItems ?? {};
  const { replaceSelectedText } = useTextEditor(editor);

  return (
    <details
      className={classNames('dropdown relative top-1.5 -left-[40px] z-20', className)}
      data-dropdown-dismiss="true"
      open={isOpen}>
      <summary
        tabIndex={0}
        role="button"
        className="btn btn-ghost btn-xs !h-[1px] !min-h-0 !w-[1px] !p-0"></summary>

      {isOpen && (
        <div className="dropdown-content relative">
          <div className="absolute">
            <EmojiPicker
              theme={Theme.AUTO}
              onEmojiClick={(emoji) => {
                replaceSelectedText(emoji.emoji);
              }}
              defaultSkinTone={skinTone}
              onSkinToneChange={(skinTone) => {
                dispatch(
                  setExtraStateItems({
                    skinTone,
                  })
                );
              }}
            />
          </div>
        </div>
      )}
    </details>
  );
};

export default FloatingEmojiDropdown;
